<template>
  <v-alert
    v-if="shouldShowError"
    color="error"
  >
    <v-row align="center">
      <v-col cols="auto">
        <v-icon color="textOnPrimary">
          mdi-alert
        </v-icon>
      </v-col>
      <v-col>
        <h3 class="error-text">
          {{ $te('errors.'+error.message) ? $t('errors.'+error.message) : error.message }}
        </h3>
      </v-col>
    </v-row>
  </v-alert>
</template>

<script>
  export default {
    name: "ApolloErrorBar",
    props: {
      error: {
        type: Error,
        default: null,
      },
    },
    computed: {
      shouldShowError() {
        if (!this.error) return false;
        // Ignore Apollo's "Store reset while query was in flight" error
        // which is a harmless cancellation error when logging in/out
        if (this.error.message && this.error.message.includes('Invariant Violation: 16')) {
          return false;
        }
        if (this.error.message && this.error.message.includes('Store reset while query was in flight')) {
          return false;
        }
        return true;
      }
    }
  };
</script>

<style scoped>
  .error-text {
    color: var(--v-textOnError-base);
  }
</style>